import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px 0px;    

    h1 {
        font-size: 35px;
        margin-bottom: 10px;
    }

    .table {
        display: table;
        //border: 1px solid #363c42;
        width: 50%;
     }
    .table .th {        
        background-color: #363c42;
        color: #fff;
        font-weight: bold;
        border-radius: 1rem 1rem 1rem 1rem;
        display: table-caption;
        text-align: -webkit-center;

    }
    .table .tr{
        display: table-row;
    }
    .table .td {
        display: table-cell;
        padding: 15px;
        //border-right: 1px solid #363c42;
        border-bottom: 1px solid #363c42;
    }

    .table .td.button {
        width: 165px;
    }

    button {
        background: rgba(242,10,118,1);
        border-radius: 100px;
        border: 1px solid rgba(242,10,118,1);
        padding-top: 5px;
        height: 53px;
        width: 170px;
        color: #ffffff;
        font-size: 15px;
    }
`;